import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import './TopBar.css';

const TopBar = () => {
	const [isSfi, setIsSfi] = useState(true);

	useEffect(() => {
		const branding = localStorage.getItem('branding');
		const isSFI = branding === 'SFI';

		setIsSfi(isSFI);
	}, []);

	return (
		<nav id="TopBar">
			<div className="topbar-left">
				<div className={`logo-container logo-sfi`}>
					<Link to="/" className="flex justify-center items-center">
						<img
							className="logo_icon logo-sfi"
							src="/icons/SFI_Logo.svg"
							alt="Logo"
						/>
					</Link>
				</div>
			</div>

			<div className="topbar-right">
				{!isSfi && (
					<div className={`logo-container logo-allstate`}>
						<Link
							to="/"
							className="flex justify-center items-center"
						>
							<img
								className="logo_icon logo-allstate"
								src="/icons/Allstate_Logo3.png"
								alt="Logo"
							/>
						</Link>
					</div>
				)}
			</div>
		</nav>
	);
};

export default TopBar;
